import { IT_BASE } from './locales/it.js';
import { EN_BASE } from './locales/en.js';
import { FR_BASE } from './locales/fr.js';
import { ES_BASE } from './locales/es.js';
import { PT_BASE } from './locales/pt.js';
import { DE_BASE } from './locales/de.js';
import { RU_BASE } from './locales/ru.js';
import { TR_BASE } from './locales/tr.js';
import { JA_BASE } from './locales/ja.js';
import { KO_BASE } from './locales/ko.js';
import { ZH_BASE } from './locales/zh.js';
import { AR_BASE } from './locales/ar.js';
import { HI_BASE } from './locales/hi.js';

export const translations = {
  it: IT_BASE, en: EN_BASE, fr: FR_BASE, es: ES_BASE, pt: PT_BASE, de: DE_BASE, ru: RU_BASE,
  tr: TR_BASE, ja: JA_BASE, ko: KO_BASE, zh: ZH_BASE, ar: AR_BASE, hi: HI_BASE
};

